import { DRIVE, FOLDER } from "icons";
import IntegrationSidebarLayout from "../components/sidebar-layout";
import IntegrationIconHeader from "../components/icon-header";

// /integrations/drive/*: Drive logo header + Folders tab.
export default function DriveIntegrationLayout() {
  return (
    <IntegrationSidebarLayout
      name="integrations-drive"
      header={<IntegrationIconHeader icon={DRIVE} title="Drive" />}
      items={[{ title: "Folders", icon: FOLDER, url: "/integrations/drive" }]}
    />
  );
}
